import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import '../../../modules/companies/register-panels'
import '../../../modules/contacts/register-panels'
import '../../../modules/deals/register-panels'
import '../../../modules/tasks/register-panels'
import { TasksView } from '../../../modules/tasks/tasks-view'
import { PANEL_TYPES } from '../../../shell/panel-state'

const tasksSearchSchema = z.object({
  q: z.string().optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  filter: FilterExprSchema.optional(),
  quick: FilterExprSchema.optional(),
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
})

export const Route = createFileRoute('/_authed/tasks/')({
  validateSearch: tasksSearchSchema,
  component: TasksRoute,
})

function TasksRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <TasksView
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => ({ ...prev, ...patch })) as never,
          replace: true,
        })
      }
    />
  )
}
